import _ from "lodash";
import React from "react";

import { BodyCopy, Headline, Subtitle } from "./Text";
import { stories } from "./stories";

const Article = ({
  setEnabled,
  enabled,
}: {
  setEnabled: (b: boolean) => void;
  enabled: boolean;
}) => {
  return (
    <article>
      <div className="title">
        <Headline Content="h2">Bedtime stories</Headline>
        <Subtitle Content="span" wobble>
          (perfectly suitable for kids)
        </Subtitle>
      </div>

      {_.map(stories, (story, i) => (
        <section key={i}>
          <Headline Content="h2" className="spooky" wobble>
            {story.title}
          </Headline>
          {_.map(story.paragraphs, (paragraph, i) => (
            <BodyCopy key={i} Content="p">
              {paragraph}
            </BodyCopy>
          ))}
        </section>
      ))}
      <a href="https://dyatmika.org/students/my-favourite-short-scary-stories/">
        <BodyCopy Content="p" className="note">
          Note, the stories on this page are not my own. They were copied from a
          Dyatamika student’s blog post — story authors remain unspecified.
        </BodyCopy>
      </a>
    </article>
  );
};

export default Article;
